import React from 'react';
import './Effects.css';
import BoxShadows from './BoxShadows';
import Filters from './Filters';
import Transforms from './Transforms';
import Transitions from './Transitions';

const Effects = ({
  selectedElement,
  updateElementStyles,
  selectedDevice,
  classStylesRegistry,
  setClassStylesRegistry
}) => {
  const handleOpacityChange = (value) => {
    updateElementStyles(
      selectedElement.id,
      "opacity",
      value,
      null,
      selectedDevice
    );
  };

  const handleBoxShadowChange = (value) => {
    updateElementStyles(
      selectedElement.id,
      "boxShadow",
      value,
      null,
      selectedDevice
    );
  };

  const handleTransformChange = (property, value) => {
    updateElementStyles(
      selectedElement.id,
      "transform",
      value,
      null,
      selectedDevice
    );
  };

  const handleFilterChange = (value) => {
    updateElementStyles(
      selectedElement.id,
      "filter",
      value,
      null,
      selectedDevice
    );
  };

  return (
    <div className="effects-container">
      <BoxShadows
        selectedElement={selectedElement}
        updateElementStyles={updateElementStyles}
        selectedDevice={selectedDevice}
        classStylesRegistry={classStylesRegistry}
        setClassStylesRegistry={setClassStylesRegistry}
      />
      <Filters
        selectedElement={selectedElement}
        updateElementStyles={updateElementStyles}
        selectedDevice={selectedDevice}
        classStylesRegistry={classStylesRegistry}
        setClassStylesRegistry={setClassStylesRegistry}
      />
      <Transforms
        selectedElement={selectedElement}
        updateElementStyles={updateElementStyles}
        selectedDevice={selectedDevice}
        classStylesRegistry={classStylesRegistry}
        setClassStylesRegistry={setClassStylesRegistry}
      />
      <Transitions
        selectedElement={selectedElement}
        updateElementStyles={updateElementStyles}
        selectedDevice={selectedDevice}
        classStylesRegistry={classStylesRegistry}
        setClassStylesRegistry={setClassStylesRegistry}
      />
    </div>
  );
};

export default Effects; 